import { SaveOutlined } from '@ant-design/icons';
import { Form, Input, Modal, Space, Typography } from 'antd';
import { useEffect } from 'react';

import { CloseIconsForModalWithDataTestId } from '@app/components';
import type { NFastCreationModal } from '@app/components/FastCreationModal/FastCreationModal.types';
import { CANCEL, ONE_TIME_CODE, SAVE } from '@app/constants';
import { ERROR_REQUIRED_FIELD } from '@app/constants/alerts';
import { numericValidator } from '@app/utils';

const { Text } = Typography;
const { TextArea } = Input;

export const FastCreationModal: NFastCreationModal.Main = ({
  title = 'Заголовок окна',
  isModalOpen,
  modalForm,
  nameMaxLength,
  descriptionMaxLength,
  isFastCreateLegalEntityModal,
  handleOk,
  handleCancel,
  finishModal,
  titleDataTestId = '',
  modalDataTestId = '',
  isLoading,
}) => {
  useEffect(() => {
    if (isModalOpen) {
      modalForm.resetFields();
    }
  }, [isModalOpen, modalForm]);

  return (
    <Modal
      data-testid={modalDataTestId}
      title={<span data-testid={titleDataTestId}>{title}</span>}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={<span data-testid="save">{SAVE}</span>}
      okButtonProps={{
        icon: <SaveOutlined />,
        loading: isLoading,
      }}
      cancelButtonProps={{ disabled: isLoading }}
      cancelText={<span data-testid="cancel">{CANCEL}</span>}
      className="modal"
      closeIcon={<CloseIconsForModalWithDataTestId />}
    >
      <Form form={modalForm} onFinish={finishModal} className="modal-form">
        <Space direction="vertical" size="large" className="form-space">
          <div className="container">
            <Text className="label-require" strong data-testid="name-title">
              Название
            </Text>

            <Form.Item
              name="Name"
              className="mg-0"
              rules={[
                {
                  required: true,
                  message: (
                    <span data-testid="name-alert">{ERROR_REQUIRED_FIELD}</span>
                  ),
                },
              ]}
            >
              <Input
                maxLength={nameMaxLength}
                size="large"
                data-testid="name-input"
              />
            </Form.Item>
          </div>

          {isFastCreateLegalEntityModal ? (
            <>
              <div className="container">
                <Text className="label-require" strong data-testid="tin-title">
                  ИНН
                </Text>

                <Form.Item
                  name="TaxPayerId"
                  className="mg-0"
                  rules={[
                    {
                      required: true,
                      message: ERROR_REQUIRED_FIELD,
                    },
                    {
                      validator: numericValidator,
                    },
                  ]}
                >
                  <Input
                    autoComplete={ONE_TIME_CODE}
                    size="large"
                    data-testid="tin-input"
                  />
                </Form.Item>
              </div>
              <div className="container">
                <Text
                  className="label"
                  strong
                  data-testid="tax-registration-number-title"
                >
                  КПП
                </Text>

                <Form.Item
                  name="Kpp"
                  className="mg-0"
                  rules={[
                    {
                      validator: numericValidator,
                    },
                  ]}
                >
                  <Input
                    autoComplete={ONE_TIME_CODE}
                    size="large"
                    data-testid="tax-registration-number-input"
                  />
                </Form.Item>
              </div>
            </>
          ) : (
            ''
          )}

          <div className="container" style={{ alignItems: 'flex-start' }}>
            <Text strong data-testid="description-title">
              Описание
            </Text>

            <Form.Item name="Description" className="mg-0">
              <TextArea
                rows={4}
                maxLength={descriptionMaxLength}
                data-testid="description-input"
              />
            </Form.Item>
          </div>
        </Space>
      </Form>
    </Modal>
  );
};
